import React, { useState, useEffect, Fragment } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';

import { setAlert } from '../../../actions/alert';
import { limpiarInstitucionConfiguracion, obtenerInstitucionConfiguracion, editarInstitucionConfiguracion } from '../../../actions/configuracion';

const EditarInstitucion = ({ institucion, reestablecerInstitucion }) => {

    const dispatch =  useDispatch();

    const { detalles_institucion } = useSelector(state => state.configuracion.educacion);

    const [editarModal, setEditarModal] = useState(false);
    const [statusProcesar, setStatusProcesar] = useState(false);

    const [institucionData, setInstitucionData] = useState({
        id: null,
        id_nivel: null,
        nombre: null
    });

    /* Editar institucion */
    const handleInputChange = ({ target }) => {
        setInstitucionData({
            ...institucionData,
            [target.name]: target.value
        });
    }
    
    const handleProcesar = async () => {
        if(institucionData.nombre){
            await setStatusProcesar(true);
            await dispatch(editarInstitucionConfiguracion(institucionData));
            await handleCerrar();
            await setStatusProcesar(false);
        }else{
            await dispatch(setAlert('Completa todos los campos', 'danger'));
        }
    }

    const handleCerrar = () => {
        if(!statusProcesar){
            setInstitucionData({
                id: null,
                id_nivel: null,
                nombre: null
            });

            setEditarModal(false);

            reestablecerInstitucion(null);
        }
    }

    useEffect(() => {
        dispatch(limpiarInstitucionConfiguracion());
    }, []);

    useEffect(() => {
        if(institucion){
            setEditarModal(true);
            
            dispatch(obtenerInstitucionConfiguracion(institucion?._id));

            setInstitucionData({
                ...institucionData,
                id: institucion?._id
            });
        }
    }, [institucion]);

    useEffect(() => {
        if(detalles_institucion){
            setInstitucionData({
                ...institucionData,
                id: detalles_institucion?._id, 
                id_nivel: detalles_institucion?.nivel, 
                nombre: detalles_institucion?.nombre
            });
        }
    }, [detalles_institucion]);

    return (
        <Fragment>
            <Modal show={editarModal} size="md" backdrop="static" centered onHide={() => handleCerrar()}>
                <Modal.Header closeButton>
                    <Modal.Title>Editar institución</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="form-group mb-3 col-md-12">
                            <div className="input-group">
                                <div className="form-floating">
                                    <input type="text" className="form-control" placeholder="Nombre" id="nombre" name="nombre" value={institucionData.nombre} onChange={e => handleInputChange(e)}/>
                                    <label htmlFor="nombre">Nombre</label>
                                </div>
                            </div>
                        </div>
                    </div>                    
                </Modal.Body>
                <Modal.Footer>
                    {
                        statusProcesar ?
                            <button type="button" className="btn btn-success" disabled><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Editar</button>
                        :
                            <button type="button" className="btn btn-success" onClick={() => handleProcesar()}><i className="fas fa-check fa-sm"></i> Editar</button>
                    }
                </Modal.Footer>
            </Modal>
        </Fragment>
    )
}

export default EditarInstitucion;